import React from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import { get } from 'lodash-es';
import classNames from 'classnames';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { InventoryModel } from 'client/data/models/inventory';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';

export function OptionDescriptionUI({ optionDescription = null, optionId, isFeaturesModal = false }) {
  // while call is being made
  if (!optionDescription) {
    return <Spinner color="gray" size={20} className="mt-0_75 mx-1_5" />;
  }

  const description = get(optionDescription, `${optionId}.description`);

  if (isFeaturesModal && !description) return null;

  return (
    <Col xs={12} id={optionId} className={classNames({ 'mt-1': !isFeaturesModal, 'mt-0_5': isFeaturesModal }, 'p-0')}>
      {description ? (
        <ul className="option-description p-0 mb-0 ps-1">
          {description.split(';').map((descriptionItem, index) => {
            const key = `${optionId}-item-${index}`;
            return (
              <li key={key} className={classNames({ 'mb-0_75': !isFeaturesModal, 'mb-0_5': isFeaturesModal })}>
                {descriptionItem}
              </li>
            );
          })}
        </ul>
      ) : (
        'Description not available'
      )}
    </Col>
  );
}

OptionDescriptionUI.propTypes = {
  optionDescription: PropTypes.objectOf(
    PropTypes.shape({
      description: PropTypes.string,
    })
  ),
  optionId: PropTypes.number.isRequired,
  isFeaturesModal: PropTypes.bool,
};

export const stateToPropsConfig = {
  optionDescription: bindToPath(({ vin }) => `optionDescription["${vin}"]`, InventoryModel),
};

export const OptionDescription = connectToModel(OptionDescriptionUI, stateToPropsConfig);

OptionDescription.propTypes = {
  vin: PropTypes.string.isRequired,
  isFeaturesModal: PropTypes.bool,
};
